<template>
  <div class="container containerCampanhaMain">
    <div class="header">
      <BannerPrincipalCampanha :params-campanha="paramsCampanha" />

      <div class="tabs-ofertas" role="tablist">
        <button
          type="button"
          class="tab-oferta"
          :class="{ 'tab-oferta--active': activeTab == 1 }"
          @click="handleSwitchbonusType(1)"
        >
          <i class="mdi mdi-percent"></i>
          <span>Descontos</span>
        </button>
        <button
          type="button"
          class="tab-oferta"
          :class="{ 'tab-oferta--active': activeTab == 2 }"
          @click="handleSwitchbonusType(2)"
        >
          <i class="mdi mdi-ticket"></i>
          <span>Bonificações</span>
        </button>
      </div>

      <div
        v-if="isAuthenticated && !showNotFound && !showAlerta"
        class="navFinder"
      >
        <div>
          <search-box
            ref="searchBox"
            class="__search"
            placeholder="Busque por uma promoção..."
            size="sm"
            :search-term="paramsCampanha.searchTerm"
            @search="searchCampaigns($event)"
          >
          </search-box>
        </div>
      </div>
      <div
        v-if="isAuthenticated && !showAlerta && activeTab == 1"
        class="nav-filters"
      >
        <div
          v-if="primaryCampanhaFilter || ctaCampanhaFilter"
          class="sublevel-controls"
        >
          <div v-if="primaryCampanhaFilter" class="sublevel-controls__left">
            <button
              type="button"
              class="subtab-campanha"
              :class="{
                'subtab-campanha--active':
                  activeFilter == primaryCampanhaFilter.type,
              }"
              @click="handleSwitchFilter(primaryCampanhaFilter.type)"
            >
              {{ primaryCampanhaFilter.name }}
            </button>
          </div>
          <div v-if="ctaCampanhaFilter" class="sublevel-controls__cta">
            <button
              type="button"
              class="cta-gera"
              :class="{
                'cta-gera--active': activeFilter == ctaCampanhaFilter.type,
              }"
              @click="handleSwitchFilter(ctaCampanhaFilter.type)"
            >
              {{ ctaCampanhaFilter.name }}
            </button>
          </div>
        </div>
        <div v-if="shouldShowStatusFilters" class="filtros-campanhas">
          <button
            v-for="filter in statusFilters"
            :key="filter.value || 'all'"
            type="button"
            class="filtro-campanha"
            :class="{
              'filtro-campanha--active': isStatusFilterActive(filter.value),
            }"
            @click="handleStatusFilterClick(filter.value)"
          >
            <span class="filtro-campanha__label">{{ filter.label }}</span>
            <span class="filtro-campanha__count">
              ({{ getStatusCount(filter.value) }})
            </span>
          </button>
        </div>
      </div>
    </div>

    <AlertCampanhaPromotion
      v-if="!isAuthenticated || showAlerta"
      :sem-pedido-aberto="isAuthenticated && !dadosPedido.razao ? true : false"
    />
    <AlertNotFoundCampanha
      v-else-if="(!showAlerta && !campanhas) || showNotFound"
    />
    <div v-else-if="!showAlerta && searchNotFound">
      <h3 class="titleNotFound">Nenhuma promoção encontrada</h3>
    </div>
    <div v-else class="containerItems">
      <div v-if="shouldShowEmptyState" class="estado-vazio-campanhas">
        <p class="estado-vazio-campanhas__title">
          Nenhuma campanha encontrada neste filtro.
        </p>
        <p class="estado-vazio-campanhas__subtitle">
          Que tal ver todas as ofertas disponíveis?
        </p>
        <button
          type="button"
          class="btn btn-primary"
          @click="resetarFiltroParaTodos"
        >
          Ver todas as ofertas
        </button>
      </div>
      <template v-else>
        <div v-for="(campanha, i) in campanhas" :key="i">
          <CampanhaAccordion
            :active="accordionActive"
            :campanha="campanha"
            :handle-accordion-active="handleAccordionActive"
          />
        </div>
      </template>
    </div>
    <div class="load-more-container">
      <center v-if="hasMoreCampaignsToShow && campanhas.length > 0">
        <button
          class="btn btn-primary btn-load-more"
          @click="loadMoreCampaigns()"
        >
          <span>Ver mais</span>
        </button>
      </center>
    </div>
  </div>
</template>

<script>
import CampanhaAccordion from "@/components/campanhas/CampanhaAccordion";
import AlertNotFoundCampanha from "@/components/campanhas/AlertNotFoundCampanha";
import BannerPrincipalCampanha from "@/components/campanhas/BannerPrincipalCampanha";
import AlertCampanhaPromotion from "@/components/campanhas/AlertCampanhaPromotion";
import SearchBox from "@/components/searchbox/SearchBox.vue";

import bus from "@/utils/events/bus";

export default {
  name: "CampanhaMain",
  components: {
    CampanhaAccordion,
    AlertCampanhaPromotion,
    AlertNotFoundCampanha,
    BannerPrincipalCampanha,
    SearchBox,
  },
  data() {
    return {
      campanhas: [],
      loadingCampanha: false,
      showAlerta: true,
      showNotFound: false,
      searchNotFound: false,
      accordionActive: 0,
      paramsCampanha: {
        offset: 0,
        searchTerm: "",
        limit: 7,
        clear: true,
        bonusType: [0, 1, 2],
      },
      activeTab: 1,
      activeFilter: "all",
      statusFilters: [
        { label: "Todos", value: null },
        { label: "Ativas", value: "acquired" },
        { label: "Parciais", value: "partial" },
        { label: "Não iniciadas", value: "notAcquired" },
      ],
      // hasMoreCampaignsToShow: false,
    };
  },
  computed: {
    hasMoreCampaignsToShow() {
      return this.$store.getters.getHasMoreCampaignsToShow;
    },
    dadosPedido() {
      return this.$store.getters.dadosPedido;
    },

    clienteId() {
      return this.dadosPedido.razao;
    },
    isAuthenticated() {
      return this.$store.getters.getIsAuthenticated;
    },
    campanhasFiltros() {
      return this.$store.getters.campanhasFiltros;
    },
    campanhasDisponiveis() {
      let campanhasDisponiveis = this.$store.getters.campanhasDisponiveis;
      if (!campanhasDisponiveis || campanhasDisponiveis == "show_not_found") {
        this.showNotFound = true;
        this.loadingCampanha = false;
        return [];
      }
      if (campanhasDisponiveis == "search_not_found") {
        this.searchNotFound = true;
        this.loadingCampanha = false;
        return [];
      }
      this.searchNotFound = false;
      this.showNotFound = false;
      return campanhasDisponiveis;
    },
    campanhasDisponiveisList() {
      const campanhas = this.$store.getters.campanhasDisponiveis;
      return Array.isArray(campanhas) ? campanhas : [];
    },
    hubPromotions() {
      return this.$store.getters.hubPromotions || [];
    },
    hubPromotionsCounters() {
      return (
        this.$store.getters.hubPromotionsCounters || {
          acquired: 0,
          partial: 0,
          notAcquired: 0,
        }
      );
    },
    primaryCampanhaFilter() {
      const filtros = Array.isArray(this.campanhasFiltros)
        ? this.campanhasFiltros
        : [];
      return (
        filtros.find((filtro) => filtro && filtro.type === "all") ||
        filtros[0] ||
        null
      );
    },
    ctaCampanhaFilter() {
      const filtros = Array.isArray(this.campanhasFiltros)
        ? this.campanhasFiltros
        : [];
      return (
        filtros.find(
          (filtro) => filtro && filtro.type && filtro.type !== "all"
        ) || null
      );
    },
    selectedStatus() {
      const statusParam = this.$route.query?.status;
      if (
        statusParam === undefined ||
        statusParam === null ||
        statusParam === ""
      ) {
        return null;
      }
      return statusParam;
    },
    hubFilterType() {
      return this.ctaCampanhaFilter
        ? this.ctaCampanhaFilter.type
        : "gera-promo";
    },
    shouldShowStatusFilters() {
      return (
        this.isAuthenticated &&
        !this.showAlerta &&
        this.activeTab === 1 &&
        this.activeFilter === this.hubFilterType
      );
    },
    statusCounters() {
      const counters = { all: 0, acquired: 0, partial: 0, notAcquired: 0 };

      if (!this.shouldShowStatusFilters) {
        return counters;
      }

      const availableCampaigns = this.campanhasDisponiveisList;
      counters.all = availableCampaigns.length;

      if (!availableCampaigns.length) {
        return counters;
      }

      const availableStatuses = ["acquired", "partial", "notAcquired"];

      availableStatuses.forEach((status) => {
        const promotionCodes = this.getHubPromotionCodesByStatus(status);
        counters[status] = this.countCampanhasByCodes(
          availableCampaigns,
          promotionCodes
        );
      });

      return counters;
    },
    shouldShowEmptyState() {
      return (
        !this.loadingCampanha &&
        Array.isArray(this.campanhas) &&
        this.campanhas.length === 0
      );
    },
  },

  watch: {
    loadingCampanha(newValue) {
      this.$store.dispatch("setShowLoadingModal", [newValue, "Main"]);
    },
    // eslint-disable-next-line func-names
    "$store.getters.dadosPedido": function (newValue, oldValue) {
      if (newValue.pedidoId != oldValue.pedidoId) {
        // Troca de cliente/pedido: a busca anterior não faz sentido no novo contexto.
        this.paramsCampanha.searchTerm = null;
        if (this.$refs.searchBox) {
          this.$refs.searchBox.searchedItemLabel = "";
          this.$refs.searchBox.busca = "";
        }
        this.showAlert();
      }
    },
    async campanhasDisponiveis(newValue, oldValue) {
      if (newValue != oldValue) {
        const allCampanhas = await this.mountCampanhasData(newValue);
        // Aplica filtro de status do hub se necessário
        this.campanhas = this.filterCampanhasByHubStatus(allCampanhas);
        if (newValue.length > 0) {
          this.loadingCampanha = false;
        }
      }
    },
    // Watch para reaplicar filtro quando status na URL mudar
    "$route.query.status": {
      handler() {
        const allCampanhas = this.campanhasDisponiveis;
        if (!allCampanhas || allCampanhas.length === 0) {
          return;
        }
        // Reaplica o filtro nas campanhas já carregadas
        this.$nextTick(() => {
          this.mountCampanhasData(allCampanhas).then((filtered) => {
            this.campanhas = this.filterCampanhasByHubStatus(filtered);
          });
        });
      },
      immediate: false,
    },
  },
  created() {
    this.loadingCampanha = true;

    if (this.$route.query?.buscaCampanha) {
      const parsed = this.parseBuscaCampanhaQuery(
        this.$route.query.buscaCampanha
      );
      if (parsed.filter) {
        this.activeFilter = parsed.filter;
        this.paramsCampanha.filter = parsed.filter;
      }
      this.paramsCampanha.searchTerm = parsed.searchTerm;
    }

    // Aplica filtro de status se presente na query
    if (this.$route.query?.status) {
      this.applyStatusFilter(this.$route.query.status);
    }

    this.showAlert();
  },

  activated() {
    const buscaCampanha = this.$route.query?.buscaCampanha;

    if (buscaCampanha) {
      const parsed = this.parseBuscaCampanhaQuery(buscaCampanha);
      const filterChanged =
        parsed.filter && this.activeFilter !== parsed.filter;

      if (filterChanged) {
        this.activeFilter = parsed.filter;
        this.paramsCampanha.filter = parsed.filter;
      }

      if (
        filterChanged ||
        parsed.searchTerm !== this.paramsCampanha.searchTerm
      ) {
        this.searchCampaigns(parsed.searchTerm);
      }
    } else if (this.paramsCampanha.searchTerm) {
      this.paramsCampanha.searchTerm = "";
      this.paramsCampanha.offset = 0;
      this.paramsCampanha.clear = true;
      this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
    }

    // Aplica filtro de status se presente na query
    if (this.$route.query?.status) {
      this.applyStatusFilter(this.$route.query.status);
    }
  },

  methods: {
    parseBuscaCampanhaQuery(raw) {
      if (!raw) return { filter: null, searchTerm: null };

      const tokens = String(raw)
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);

      const hubCodes = [];
      const localCodes = [];

      for (const token of tokens) {
        if (token.startsWith("hub:")) {
          const parts = token.split(":");
          if (parts.length >= 3) {
            hubCodes.push(parts.slice(2).join(":"));
          }
        } else {
          localCodes.push(token);
        }
      }

      // Quando tem só hub, vai pra aba do hub.
      // Em qualquer caso com local (incluindo misto), prioriza local: aba "all" + códigos locais.
      if (hubCodes.length && !localCodes.length) {
        return {
          filter: this.hubFilterType,
          searchTerm: hubCodes.join(","),
        };
      }

      return {
        filter: "all",
        searchTerm: localCodes.length ? localCodes.join(",") : raw,
      };
    },
    handleSwitchbonusType(type) {
      if (type == this.activeTab) return;

      this.activeTab = type;

      switch (type) {
        case 1:
          this.paramsCampanha.bonusType = [0, 1, 2];
          break;
        case 2:
          this.paramsCampanha.bonusType = [3];
          break;
      }

      this.activeFilter = "all";

      this.loadingCampanha = true;

      this.paramsCampanha.filter = this.activeFilter;

      this.paramsCampanha.searchTerm = null;
      this.paramsCampanha.offset = 0;
      this.paramsCampanha.clear = true;

      if (this.$refs.searchBox) {
        this.$refs.searchBox.searchedItemLabel = "";
        this.$refs.searchBox.busca = "";
      }

      this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
    },
    handleSwitchFilter(type) {
      if (type == this.activeFilter) return;

      const hubFilterType = this.hubFilterType;
      const switchingToHub = type === hubFilterType;

      // Se estiver saindo do hub (+Gera), remove o status da URL
      if (!switchingToHub) {
        this.clearStatusQuery();
      }

      this.activeFilter = type;

      this.paramsCampanha.filter = this.activeFilter;

      this.loadingCampanha = true;

      this.paramsCampanha.searchTerm = null;
      this.paramsCampanha.offset = 0;
      this.paramsCampanha.clear = true;

      if (this.$refs.searchBox) {
        this.$refs.searchBox.searchedItemLabel = "";
        this.$refs.searchBox.busca = "";
      }

      this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
    },
    handleStatusFilterClick(status) {
      const normalizedStatus = status || null;
      const currentStatus = this.selectedStatus || null;
      if (normalizedStatus === currentStatus) {
        return;
      }

      const newQuery = { ...this.$route.query };

      if (!normalizedStatus) {
        delete newQuery.status;
      } else {
        newQuery.status = normalizedStatus;
      }

      this.$router.push({ path: this.$route.path, query: newQuery });
    },
    clearStatusQuery() {
      if (!this.$route.query?.status) {
        return;
      }

      const newQuery = { ...this.$route.query };
      delete newQuery.status;

      this.$router.replace({ path: this.$route.path, query: newQuery });
    },
    isStatusFilterActive(value) {
      const normalizedValue = value || null;
      const currentStatus = this.selectedStatus || null;
      return normalizedValue === currentStatus;
    },
    getStatusCount(value) {
      if (!value) {
        return this.statusCounters.all;
      }
      return this.statusCounters[value] || 0;
    },
    resetarFiltroParaTodos() {
      const hubFilterType = this.hubFilterType;

      if (this.selectedStatus) {
        this.handleStatusFilterClick(null);
      }

      if (hubFilterType && this.activeFilter !== hubFilterType) {
        this.handleSwitchFilter(hubFilterType);
      }
    },
    handleAccordionActive(campanhaId) {
      this.accordionActive = campanhaId;
    },
    searchCampaigns(searchTerm) {
      this.loadingCampanha = true;

      this.paramsCampanha.searchTerm = searchTerm;
      this.paramsCampanha.offset = 0;
      this.paramsCampanha.clear = true;
      this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
    },

    async mountCampanhasData(campanhas) {
      // Garante que campanhas é um array
      if (!Array.isArray(campanhas)) {
        return [];
      }

      campanhas = JSON.parse(JSON.stringify(campanhas));

      let newcampanhas = campanhas.map(async (campanha) => {
        if (!campanha.grupos_ativacao || !campanha.grupos_ativacao.length) {
          return {};
        }
        campanha.active = campanha.id === this.accordionActive;
        campanha.descricao = campanha.descricao.toLowerCase();
        return campanha;
      });
      newcampanhas = await Promise.all(newcampanhas);
      // Remove objetos vazios
      return newcampanhas.filter((c) => c && Object.keys(c).length > 0);
    },
    isValidHubStatus(status) {
      return ["partial", "acquired", "notAcquired"].includes(status);
    },
    getHubPromotionCodesByStatus(status) {
      if (!this.isValidHubStatus(status)) {
        return [];
      }

      const hubPromotions = this.hubPromotions || [];
      if (!hubPromotions.length) {
        return [];
      }

      return hubPromotions
        .filter((promo) => promo.status === status && (promo.code || promo.id))
        .map((promo) => String(promo.code || promo.id));
    },
    countCampanhasByCodes(campanhas, codes) {
      if (!Array.isArray(campanhas) || !campanhas.length || !codes.length) {
        return 0;
      }

      const codesSet = new Set(codes);
      return campanhas.reduce((counter, campanha) => {
        const campanhaId = String(campanha.id || campanha.code || "");
        if (campanhaId && codesSet.has(campanhaId)) {
          return counter + 1;
        }
        return counter;
      }, 0);
    },
    /**
     * Filtra campanhas baseado no status do hub
     * @param {Array} campanhas Lista de campanhas para filtrar
     * @returns {Array} Campanhas filtradas
     */
    filterCampanhasByHubStatus(campanhas) {
      if (this.activeFilter !== this.hubFilterType) {
        return campanhas;
      }
      // Se não há query parameter de status, retorna todas as campanhas
      const statusFilter = this.$route.query?.status;
      if (!statusFilter || !this.isValidHubStatus(statusFilter)) {
        return campanhas;
      }

      // Extrai os códigos/IDs das promoções com o status desejado
      const promotionCodesByStatus =
        this.getHubPromotionCodesByStatus(statusFilter);

      // Se não encontrou promoções com o status, retorna array vazio
      if (promotionCodesByStatus.length === 0) {
        return [];
      }

      const promotionCodesSet = new Set(promotionCodesByStatus);

      // Filtra as campanhas pelos IDs/códigos
      return campanhas.filter((campanha) => {
        // O ID da campanha pode estar em 'id' ou 'code'
        const campanhaId = String(campanha.id || campanha.code || "");
        return campanhaId && promotionCodesSet.has(campanhaId);
      });
    },

    loadMoreCampaigns() {
      this.paramsCampanha.offset += this.paramsCampanha.limit;
      this.paramsCampanha.clear = false;
      this.loadingCampanha = true;
      this.$store
        .dispatch("getCampanhasDisponiveis", this.paramsCampanha)
        .then(() => {
          // O filtro será aplicado automaticamente no watcher de campanhasDisponiveis
        });
    },
    /**
     * Aplica filtro de status do hub
     * Busca as campanhas do hub e aplica o filtro no frontend
     */
    applyStatusFilter(status) {
      // Verifica se é um status válido do hub
      if (!["partial", "acquired", "notAcquired"].includes(status)) {
        return;
      }

      // Aguarda os filtros serem carregados para identificar qual hub usar
      this.$nextTick(() => {
        const filtros = this.campanhasFiltros;

        if (!filtros || filtros.length === 0) {
          // Se os filtros ainda não foram carregados, tenta novamente após um delay
          setTimeout(() => this.applyStatusFilter(status), 500);
          return;
        }

        // Procura o filtro do hub (gera-promo ou outro hub ativo)
        const hubFilter = filtros.find((f) => f.type !== "all" && f.type);

        if (hubFilter) {
          // Se encontrou um hub, aplica o filtro do hub (sem status, pois filtraremos no frontend)
          this.activeFilter = hubFilter.type;
          this.paramsCampanha.filter = hubFilter.type;
          this.loadingCampanha = true;
          this.paramsCampanha.searchTerm = null;
          this.paramsCampanha.offset = 0;
          this.paramsCampanha.clear = true;

          if (this.$refs.searchBox) {
            this.$refs.searchBox.searchedItemLabel = "";
            this.$refs.searchBox.busca = "";
          }

          // Busca as campanhas do hub (sem filtro de status no backend)
          // O filtro será aplicado automaticamente no watcher de campanhasDisponiveis
          this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
        } else {
          // Se não encontrou hub específico, tenta usar 'gera-promo' como padrão
          this.activeFilter = "gera-promo";
          this.paramsCampanha.filter = "gera-promo";
          this.loadingCampanha = true;
          this.paramsCampanha.offset = 0;
          this.paramsCampanha.clear = true;
          // O filtro será aplicado automaticamente no watcher de campanhasDisponiveis
          this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
        }
      });
    },

    async showAlert() {
      if (!this.clienteId || !this.isAuthenticated || !this.dadosPedido.razao) {
        this.campanhas = [];
        this.showAlerta = true;
        this.loadingCampanha = false;
      } else {
        // if (!this.campanhas.length) {
        this.showAlerta = false;
        this.loadingCampanha = true;
        // await this.findCampanhas();
        this.paramsCampanha.clear = true;
        this.paramsCampanha.offset = 0;
        this.$store.dispatch("getCampanhasDisponiveis", this.paramsCampanha);
        // }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/_variables.scss";

.containerCampanhaMain {
  padding: 15px;

  .tabs-ofertas {
    display: flex;
    gap: 12px;
    width: 100%;
    margin: 20px 0 15px;

    @media (max-width: 548px) {
      flex-direction: column;
    }
  }

  .tab-oferta {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 20px;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    background: #fff;
    color: var(--brand-primary, $brand-primary);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    i {
      font-size: 20px;
    }

    &:hover {
      background: var(--brand-primary, $brand-primary);
      border-color: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);

      i {
        color: inherit;
      }
    }

    &:active {
      transform: scale(0.98);
    }

    &--active {
      background: var(--brand-primary, $brand-primary);
      border-color: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);

      i {
        color: inherit;
      }
    }
  }

  .header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .navFinder {
      margin: 15px 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .__search {
        width: 500px;
      }

      select {
        background: transparent;
        border: none;
        color: #1ba256;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .nav-filters {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 10px;
    }
  }

  .sublevel-controls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    padding: 6px 0;
    flex-wrap: wrap;

    &__left {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 0 0 auto;
    }

    &__cta {
      display: flex;
      justify-content: flex-start;
      flex: 0 0 auto;
      min-width: 140px;

      @media (max-width: 640px) {
        width: 100%;
        justify-content: flex-start;
      }
    }
  }

  @media (max-width: 548px) {
    .sublevel-controls {
      &__left,
      &__cta {
        flex: 1 1 calc(50% - 6px);
      }

      .subtab-campanha,
      .cta-gera {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .subtab-campanha {
    min-width: 140px;
    padding: 10px 20px;
    border-radius: 999px;
    border: 1px solid #dfe3e8;
    background: #fff;
    color: var(--brand-primary, $brand-primary);
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: var(--brand-primary, $brand-primary);
      border-color: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: scale(0.98);
    }

    &--active {
      background: var(--brand-primary, $brand-primary);
      border-color: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
    }
  }

  .cta-gera {
    padding: 10px 26px;
    border-radius: 999px;
    color: var(--brand-primary, $brand-primary);
    border: 1px solid var(--brand-primary, $brand-primary);
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

    &:hover {
      background: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      border-color: var(--brand-primary, $brand-primary);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }

    &:active {
      transform: scale(0.98);
    }

    &--active {
      background: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      border-color: var(--brand-primary, $brand-primary);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }

  .filtros-campanhas {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
  }

  .filtro-campanha {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #dfe3e8;
    border-radius: 999px;
    padding: 9px 20px;
    background: #f7f9fc;
    color: var(--brand-primary, $brand-primary);
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: #eef2fb;
    }

    &:active {
      transform: scale(0.98);
    }

    &__label {
      color: currentColor;
    }

    &__count {
      font-size: 12px;
      color: #7a8a99;
    }

    &--active {
      background: var(--brand-primary, $brand-primary);
      border-color: var(--brand-primary, $brand-primary);
      color: var(--brand-primary-contrast, #fff);
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);

      .filtro-campanha__count {
        color: var(--brand-primary-contrast, #fff);
      }

      &:hover {
        background: var(--brand-primary, $brand-primary);
        filter: brightness(1.05);
      }
    }
  }

  .estado-vazio-campanhas {
    width: 100%;
    text-align: center;
    padding: 40px 20px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    background: #fff;
    margin: 20px 0;

    &__title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #27323f;
    }

    &__subtitle {
      font-size: 14px;
      color: #5b6776;
      margin-bottom: 20px;
    }
  }

  .titleNotFound {
    margin: 32px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #27323f;
  }

  .containerItems {
    .loadingContent {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
    }
  }

  .load-more-container {
    margin: 24px 0;
    text-align: center;

    .btn-load-more {
      padding: 12px 32px;
      font-size: 14px;
      font-weight: 600;
      border-radius: 5px;
      min-width: 140px;
      transition: all 200ms ease-in;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }

      @media (max-width: 548px) {
        padding: 10px 24px;
        font-size: 13px;
        min-width: 120px;
      }
    }
  }
}

@media (max-width: 968px) {
  .containerCampanhaMain {
    .header {
      .navFinder {
        .__search {
          width: 300px;
        }
      }
    }
  }
}
@media (max-width: 728px) {
  .containerCampanhaMain {
    .header {
      .navFinder {
        gap: 20px;
      }
    }
  }
}
</style>
